import { useCallback, useEffect } from 'react';
import { TOTAL_REMOTE_LOADING_TIME, abortTracking } from '@adsk/exo-skeleton-api';
import { REMOTE_TRACKING_TIMEOUT } from '../helpers/consts';
import { useRemote } from '../providers/RemoteProvider';
export const useRemoteTrackingHandler = _ref => {
  let {
    moduleName,
    scope
  } = _ref;
  const {
    trackLoading
  } = useRemote();
  const abortTrackingHandler = useCallback(_ref2 => {
    let {
      reason
    } = _ref2;
    return abortTracking({
      scope,
      moduleName,
      trackingId: TOTAL_REMOTE_LOADING_TIME,
      reason
    });
  }, [scope, moduleName]);
  useEffect(() => {
    trackLoading();
    const timeout = setTimeout(() => {
      void abortTrackingHandler({
        reason: 'timeout'
      });
    }, REMOTE_TRACKING_TIMEOUT);
    return () => {
      void abortTrackingHandler({
        reason: 'unmount'
      });
      clearTimeout(timeout);
    };

    // for every scope or moduleName changes, we need to abort the previous tracking and start a new one
  }, [scope, moduleName, abortTrackingHandler, trackLoading]);
};
//# sourceMappingURL=useRemoteTrackingHandler.js.map